/** @format */
// 配置业务类型 // 00：临停缴费 01：电子找零 02：车位固定收费账户
export enum DictBizType {
  TempParking = '00',
  ECharge = '01',
  FixedParking = '02'
}
export const dictBizTypeMap: {
  [key: string]: string;
} = {
  [DictBizType.TempParking]: '临停缴费',
  [DictBizType.ECharge]: '电子找零',
  [DictBizType.FixedParking]: '车位固定收费账户'
};

// 招行
export interface IZhaohangData {
  id?: string;
  cmbAppId: string;
  cmbAppKey: string;
  wxAppId: string;
  wxMchId: string;
  wxApiKey: string;
  wxAppSecret: string;
  aliAppId: string;
  aliPartnerId: string;
  aliRsaPrivateKey: string;
  aliPublicKey: string;
  chkAccount: string;
  chkPassword: string;
}

export const zhaohangDataDefault = {
  id: '',
  cmbAppId: '',
  cmbAppKey: '',
  wxAppId: '',
  wxMchId: '',
  wxApiKey: '',
  wxAppSecret: '',
  aliAppId: '',
  aliPartnerId: '',
  aliRsaPrivateKey: '',
  aliPublicKey: '',
  chkAccount: '',
  chkPassword: ''
};

// 交行
export interface IJiaohangData {
  id?: string;
  merchantNo: string;
  merchantKey: string;
  wxAppId: string;
  wxMchId: string;
  wxApiKey: string;
  wxAppSecret: string;
  aliAppId: string;
  aliPartnerId: string;
  aliRsaPrivateKey: string;
  aliPublicKey: string;
  chkAccount: string;
  chkPassword: string;
}

export const jiaohangDataDefault = {
  id: '',
  merchantNo: '',
  merchantKey: '',
  wxAppId: '',
  wxMchId: '',
  wxApiKey: '',
  wxAppSecret: '',
  aliAppId: '',
  aliPartnerId: '',
  aliRsaPrivateKey: '',
  aliPublicKey: '',
  chkAccount: '',
  chkPassword: ''
};

// 银联
export interface IUnionData {
  id?: string;
  merchantcode: string;
  merchantNo: string;
  bankAccount: string;
  wxAppId: string;
  aliAppId: string;
}

export const unionDataDefault = {
  id: '',
  merchantcode: '',
  merchantNo: '',
  bankAccount: '',
  wxAppId: '',
  aliAppId: ''
};

// 统一
export interface IUnifiedData {
  id?: string;
  merchantcode: string;
  wxAppId: string;
  aliAppId: string;
  bankAccount: string;
  merchantNo: string;
}

export const unifiedDataDefault = {
  id: '',
  merchantcode: '',
  wxAppId: '',
  aliAppId: '',
  bankAccount: '',
  merchantNo: ''
};

// 账单中心
export interface IUnifiedDatacenter {
  id?: string;
  merchantKey: string;
  merchantNo: string;
}

// 账单中心
export interface IUnifiedDatacenter {
  id?: string;
  merchantKey: string;
  merchantNo: string;
}

export const unifiedDataDefaultcenter = {
  id: '',
  merchantKey: '',
  merchantNo: ''
};
